<template>
    <div class="full-size">
      <buttons-group
          :items="items"
          :indexStep="index"
          :disabledAll="true"
          :width="270"
          @click="getIndex"
      />
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      items: [
        'Atualização de Beneficários',
        'Gerenciamento de Token',
        //'Atualização Cadbenef'
      ],
      disabled: true,
      role: jwtDecode(localStorage.getItem('tokenBearer')).role
    }
  },
  methods: {
    getIndex (index) {
      this.$emit('changeAll', { tabName: this.getTabName(index), index })
    },
    getTabName (tab) {
      const tabsName = {
        0: () => 'Atualização de Beneficários',
        1: () => 'Gerenciamento de Token',
        //2: () => 'Atualização Cadbenef'
      }

      return (tabsName[tab] || tabsName['Atualização de Beneficários'])()
    },
    isAdminBrasil () {
      return (this.role === 'admin_brasil')
    }
  }
}
</script>

<style lang="sass" scoped>
.full-size
  width: 105% !important
</style>
